export const setThemeColor = (...inputs) => {
  const color = inputs[0]
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);
  return color;
}